import { CONTEXT_TYPES } from '@nandosaus/constants';
import { types } from 'mobx-state-tree';

import { GeneralContext } from './general-context';
import { PresetContext } from './preset-context';

/** Contexts represent a set of restrictions that are placed on what ordering settings can be changed
 *
 * They _must_ have the following properties
 * - type: unique string value for telling them apart
 * - availableOrderTypes: which ordering types a user can manually select
 *
 * They _may_ have the following properties
 * - writableFields: list of properties that can be set on the current fulfilment (settings).
 * Defaults to the current fulfilment.writableFields
 *
 * They _may_ have the following actions
 * - init: a method called inside `setContext` which allows the context to do some processing before it
 * becomes live. A fulfilment can be returned from this method which will be applied to the store
 */

const Map = {
  [CONTEXT_TYPES.GENERAL]: GeneralContext,
  [CONTEXT_TYPES.PRESET]: PresetContext,
  // [CONTEXT_TYPES.GROUP]: GroupContext,
};

const Context = types.union(...Object.values(Map));

export default Context;
export { Map, GeneralContext, PresetContext };
